export const RESET_REQUEST_ERROR_DATA = "RESET_REQUEST_ERROR_DATA";
export const SET_SAVE_INDICATOR = "SET_SAVE_INDICATOR";
export const SET_UPDATE_INDICATOR = "SET_UPDATE_INDICATOR";
export const SET_DELETE_INDICATOR = "SET_DELETE_INDICATOR";
export const SET_FETCH_INDICATOR = "SET_FETCH_INDICATOR";
